import SurveySchema from '@ax2/common/model/schemas/SurveySchema';
import _ from 'lodash';
import { getQuestionsValidation } from './questionBuilderValidations';
import QuestionType from '@ax2/common/model/QuestionType';

export const isQuestionsValid = (survey: SurveySchema | null) => {
  const errors = survey ? getQuestionsValidation(survey.questions) : [];
  return (
    !!survey &&
    survey.questions.length > 0 &&
    survey.questions.length < 11 &&
    _.findIndex(errors, e => !!e) === -1
  );
};

export const getSurveyErrors = (survey: SurveySchema | null) => {
  const isSurveyQuestionsValid = isQuestionsValid(survey);
  const isSurveyNameValid = isNameValid(survey);

  const errors: string[] = [];
  if (!survey) {
    errors.push('Survey should existed');
  }
  if (survey && survey.questions.length === 0) {
    errors.push('At least one question should be added');
  }
  if (!isSurveyNameValid) {
    errors.push('Survey name should be specified before processing');
  }
  if (!isSurveyQuestionsValid) {
    errors.push(
      'There are some questions below that need to be reviewed before processing'
    );
  }
  if (
    survey &&
    _.filter(
      survey.questions,
      q => q.questionType === QuestionType.OpenEndedText
    ).length > 3
  ) {
    errors.push('Survey should have no more than 3 open response questions');
  }
  return errors;
};

export const isScreenersValid = (survey: SurveySchema | null) => {
  const errors = survey ? getQuestionsValidation(survey.screeners) : [];
  return !!survey && _.findIndex(errors, e => !!e) === -1;
};
export const isNameValid = (survey: SurveySchema | null) =>
  !!survey && !!survey.title && survey.title.length > 0;

export function getQuestionTypeName(qType: QuestionType) {
  switch (qType) {
    case QuestionType.Empty:
      return null;
    case QuestionType.CheckboxList:
      return 'Select all that apply';
    case QuestionType.CheckboxGrid:
      return 'Select all that apply grid';
    case QuestionType.DropdownMenu:
      return 'Dropdown menu';
    case QuestionType.OpenEndedText:
      return 'Open-end text (single)';
    case QuestionType.OpenEndedNumeric:
      return 'Numeric (single)';
    case QuestionType.RadioButtonGrid:
      return 'Select one grid';
    case QuestionType.RadioButtonGridRow:
      return 'Select one per row';
    case QuestionType.RadioButtonList:
      return 'Select one';
    case QuestionType.RatingList:
      return 'Rating scale (multiple)';
    case QuestionType.TextboxGridNumeric:
      return 'Numeric grid';
    case QuestionType.TextboxListNumeric:
      return 'Numeric (multiple)';
    case QuestionType.TextboxListText:
      return 'Open-end text (multiple)';
    case QuestionType.ContinuousSumList:
      return 'Sum to 100 points';
    case QuestionType.RankingList:
      return 'Ranking';
    default:
      return 'Unknown type';
  }
}
